import { MainCard, MainCardTitle } from "src/components/main-card-type.tsx";
import { normalSanatizerBRL } from "src/utils/functions";
import { CDBResponse } from "../utilis/calculo";
import { CalculadoraCDBTable } from "./calculadora-cdb-table";

export const CalculadoraCDBResponse = ({
  results,
}: {
  results: CDBResponse;
}) => {
  return (
    <MainCard className="mt-4">
      <MainCardTitle>Resultado</MainCardTitle>
      <div className="sm:grid-cols-3 w-1/2 mb-3 mx-auto">
        <div className="p-3 bg-primary rounded border flex flex-col justify-center">
          <h2 className="sm:text-base text-sm text-center text-white font-semibold m-0">
            CDB - Valor Final Bruto
          </h2>
          <p className="sm:text-xl text-center font-bold text-md text-white m-0">
            <span className="text-sm mr-1 text-white">R$</span>
            {normalSanatizerBRL(results.valorFinal)}
          </p>
        </div>
      </div>
      <CalculadoraCDBTable results={results} />
    </MainCard>
  );
};
